/**
 * Privacy Route
 * 
 * Loads the UserPreferences MFE with /privacy initialPath.
 * Clean top-level route so URL is exactly what the MFE expects.
 * 
 * @module components/mfe/PrivacyRoute
 */

import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MFELoader } from './MFELoader';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';
import '@/components/menu/MenuScreen.css';

export const PrivacyRoute: React.FC = () => {
  const { user, logout } = useAuth();
  const token = CommunicationBridge.getAccessToken();

  const handleBack = () => {
    window.location.href = '/account';
  };

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <div className="menu-container">
      <div className="menu-header">
        <div className="menu-header-content">
          <button className="menu-back-button" onClick={handleBack}>
            <ChevronLeftIcon />
          </button>
          <h2 className="menu-header-title">Privacy</h2>
        </div>
      </div>
      <div className="menu-scroll-content menu-scroll-content-mfe">
        <ErrorBoundary onReset={() => window.location.reload()}>
          <MFELoader
            mfeName="UserPreferences"
            accessToken={token}
            refUserId={user.id}
            onLogout={logout}
            initialPath="/privacy"
          />
        </ErrorBoundary>
      </div>
    </div>
  );
};

